import React from 'react';
import Notifications from './Notifications';
import useIsBrowserReady from '../hooks/useIsBrowserReady';
var NotificationsLoader = function NotificationsLoader(props) {
  var isBrowser = useIsBrowserReady();
  if (!isBrowser) return null;
  return /*#__PURE__*/React.createElement("div", {
    id: "site-notifications-wrapper",
    style: {
      display: 'flex'
    }
  }, /*#__PURE__*/React.createElement(Notifications, props));
};
export default NotificationsLoader;
//# sourceMappingURL=index.js.map